import styled from 'styled-components'
import MobileBgImage from '~/assets/images/campaign-anniversary7/page-mobile-bg.png'
import PcBgImage from '~/assets/images/campaign-anniversary7/page-pc-bg.png'

export const StyledPage = styled.div`
  background: #080706;
`

export const Main = styled.main`
  position: relative;
  isolation: isolate;
  display: grid;
  min-height: calc(100vh - 84px);
  grid-template-rows: 1fr auto;
  overflow: hidden;
  background-color: #080706;
  background-image: url(${PcBgImage.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    background: rgba(0, 0, 0, 0.05);
  }

  ${({ theme }) => theme.media.lg`
    min-height: calc(100vh - 60px);
  `}

  ${({ theme }) => theme.media.sm`
    background-image: url(${MobileBgImage.src});
  `}
`

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 82px 20px 34px;

  ${({ theme }) => theme.media.sm`
    justify-content: flex-start;
    padding: 105px 16px 16px;
  `}
`

export const Hero = styled.section`
  display: flex;
  width: min(541px, 100%);
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const HeroSeven = styled.img`
  display: block;
  width: 221px;
  height: 272px;
  object-fit: contain;
  opacity: 0.88;

  ${({ theme }) => theme.media.sm`
    width: 142px;
    height: 174px;
  `}
`

export const HeroTitle = styled.h1`
  margin: 10px 0 16px;
  font-size: 42px;
  font-weight: 900;
  color: #fff;

  ${({ theme }) => theme.media.sm`
    width: 252px;
    margin: 11px 0 16px;
    font-size: 36px;
  `}
`

export const HeroSubtitle = styled.p`
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 73.5px;
  margin: 0;
  padding: 0 16px;
  background: linear-gradient(
    90deg,
    rgba(151, 62, 221, 0) 0%,
    #973edd 48.56%,
    rgba(151, 62, 221, 0) 100%
  );
  font-size: 24px;
  color: #fff;

  &::before,
  &::after {
    content: '';
    position: absolute;
    right: 0;
    left: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      #040404 0%,
      rgba(255, 255, 255, 0.5) 50%,
      #040404 100%
    );
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
  }

  ${({ theme }) => theme.media.sm`
    width: 325px;
    height: 50px;
    padding: 0 12px;
    font-size: 18px;
  `}
`

export const PrimaryButton = styled.button`
  box-sizing: border-box;
  display: flex;
  width: 220px;
  min-height: 58px;
  align-items: center;
  justify-content: center;
  margin-top: 58px;
  padding: 0 28px;
  border: 0;
  border-radius: 80px;
  color: #fff;
  background: #5f4dbc;
  font-size: 16px;
  font-weight: 500;
  cursor: not-allowed;
  opacity: 0.72;

  ${({ theme }) => theme.media.sm`
    margin-top: 40px;
  `}
`

export const PageInfo = styled.div`
  display: flex;
  height: 52px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #767676;
  background: rgba(24, 24, 23, 0.6);
  font-size: 14px;
  line-height: 1.3;
  text-align: center;
`

export const PageInfoItem = styled.span`
  white-space: nowrap;
`

export const PageInfoLink = styled.a`
  color: inherit;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`

export const PageInfoDivider = styled.span`
  width: 1px;
  height: 10px;
  flex: 0 0 auto;
  background: #767676;
`
